export default {
  'cycle.defaultCycle': {
    ko: '디폴트 수집 주기',
    ja: 'デフォルトの収集間隔',
    en: 'Default cycle',
    cn: '',
  },
  'cycle.cycle': {
    ko: '수집주기',
    ja: '収集間隔',
    en: 'Cycle',
    cn: '',
  },
  'cycle.avoidanceTime': {
    ko: '수집 회피 시간대',
    ja: '収集回避の時間帯',
    en: 'Collect Avoidance Time',
    cn: '',
  },
  'cycle.collectYn': {
    ko: '수집여부',
    ja: '収集有無',
    en: 'Collect Y/N',
    cn: '',
  },
  'cycle.target': {
    ko: '수집대상',
    ja: '収集対象',
    en: 'Collection target',
    cn: '',
  },
};
